import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import SignatureCanvas from './SignaturePad';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class ESigningModal extends Component {
  static propTypes = {
    trigger: PropTypes.node,
    onClose: PropTypes.func,
    cancelButton: PropTypes.node,
    saveButton: PropTypes.node,
    loading: PropTypes.bool,
    open: PropTypes.bool,
    t: PropTypes.func,
  }

  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      modalOpen: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { open } = nextProps;
    if (open) {
      this.setState({
        open,
      });
    }
  }

  handleOnOpen = (e) => {
    e.preventDefault();
    this.setState({ open: true });
  }
  close() {
    this.handleOnClose(true);
  }
  handleOnClose = (force = false) => {
    let open = false;
    if (!force && this.props.onClose) {
      open = this.props.onClose();
    }
    this.setState({ open });
  }
  handleOnCancel = () => {
    this.signaturePad.clear();
    this.close();
  }
  signData() {
    return this.signaturePad.getTrimmedCanvas().toDataURL();
  }

  isEmpty() {
    if (this.signaturePad.isEmpty()) {
      return true;
    }
    return false;
  }

  clear = (e) => {
    e.preventDefault();
    this.signaturePad.clear();
  }
  render() {
    const { trigger, saveButton, cancelButton, t } = this.props;
    return (
      <Modal
        className="signature"
        closeOnDimmerClick={false}
        size={window.innerWidth < 1200 ? 'fullscreen' : 'large'}
        trigger={trigger}
        open={this.state.open}
        onClose={this.handleOnCancel}
        onOpen={this.handleOnOpen}
      >
        <Modal.Content>
          <div className="wrapper">
            <div>
              <SignatureCanvas
                loading={this.props.loading}
                ref={(ref) => { this.signaturePad = ref; }}
                backgroundColor="transparent"
                canvasProps={{ width: window.innerWidth, height: window.innerHeight - 100, className: 'signaturePad' }}
              />
            </div>
          </div>
          <p>{t('Sign above')}</p>
          <p style={{ fontWeight: '200' }} ><em>{t('Sign note')}</em></p>
        </Modal.Content>
        <Modal.Actions className="text-center">
          <Button onClick={this.clear} disabled={this.props.loading} basic color="grey" content={t('Clear')} />
          {cancelButton || <Button onClick={this.handleOnCancel} disabled={this.props.loading} basic color="grey" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />}
          {saveButton}
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(ESigningModal);



// WEBPACK FOOTER //
// ./src/components/SignaturePad/ESigningModal.jsx